import styled from 'styled-components';
import theme from 'utils/styles/theme';
import Text from 'components/Text';
import sp from 'styled-props';

const sizes = {
	small: theme.fontSizes.pSmall,
	large: theme.fontSizes.pLarge
};

const Paragraph = styled(Text).attrs({
	as: 'p'
})`
	font-size: ${sp(sizes)};
`;

Paragraph.defaultProps = {
	lineHeight: 'copy',
	fontSize: ['16px', 'p']
};

export default Paragraph;
